import "./EditVideoProperties.html";

import type { IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import EditVideoPropertiesComponentController from "./EditVideoPropertiesComponentController";

export class EditVideoPropertiesComponent implements ng.IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    public transclude: boolean;

    constructor() {
        this.bindings = {
            resolve: "<",
        };
        this.controller = EditVideoPropertiesComponentController;
        this.templateUrl =
            "/App/Components/EquipmentFunctionalityType/" +
            "VideoProperties/EditVideoProperties/EditVideoProperties.html";
    }
}

module("mmManagePortal").component("irEditFunctionalityVideoProperties", new EditVideoPropertiesComponent());
